export enum ExciseRateType {
    PerLiter = "PerLiter",
    PerHectoliter = "PerHectoliter",
    PerAlcoholPercentage = "PerAlcoholPercentage",
    Fixed = "Fixed"
}
